import { AdminAppState } from '../../state';
import { getEventTags } from './get-event-tags';
import { identity } from 'lodash';

export const getEventTagsArray = (eventKey: string) => (
  state: AdminAppState,
): string[] =>
  getEventTags(eventKey)(state)
    .split(/(\s+|,)/)
    .map(tag => tag.trim())
    .filter(identity);
